import React from 'react'

export default () => <div>Contact</div>
